import React, { useEffect, useState } from "react";

import "sweetalert2/dist/sweetalert2.min.css";

import { notification } from "antd";
import { useSelector } from "react-redux";
import fetchSiteList from "../../../api/sites/fetchSiteList";
const PickupEmail = () => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  const isAuthenticated = useSelector((state) => state.user);
  const isSuperAdmin =
    String(isAuthenticated?.role || "").toLowerCase() === "superadmin";
  const [sites, setSites] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);

  const [credentials, setCredentials] = useState({
    email: "",
    id: "",
  });
  const handleInput = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (!isSuperAdmin) return;
    (async () => {
      const siteData = await fetchSiteList();
      const list = siteData?.site_data || [];
      setSites(list);
      if (list[0]?._id) {
        setSiteId(list[0]._id);
        getData(list[0]._id);
      }
    })();
  }, []);

  const getData = async (selectedSiteId) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("auth-token", localStorage.getItem("token"));
    const response = await fetch(
      `${url}/api/communication/getPEmail?site_id=${selectedSiteId || siteId}`,
      {
        mode: "cors",
        method: "get",
        headers: headers,
      }
    );
    const json = await response.json();
    if (json.success) {
      let usr = json.data;
      setCredentials({
        email: usr.email,
        id: usr._id,
      });
    } else {
      setCredentials({ email: "", id: "" });
    }
    setIsDisplay(false);
  };

  const handleChange = () => {
    setIsDisplay(true);
  };

  const handleSiteChange = (e) => {
    const nextSiteId = e.target.value;
    setSiteId(nextSiteId);
    getData(nextSiteId);
  };

  const handleSubmit = async () => {
    if (!isSuperAdmin) return;
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      setIsLoading(true);
      if (credentials?.id) {
        const response = await fetch(
          `${url}/api/communication/updatePEmail/${credentials?.id}`,
          {
            mode: "cors",
            method: "PUT",
            headers: headers,
            body: JSON.stringify({
              email: credentials.email,
              site_id: siteId,
            }),
          }
        );
        setIsLoading(false);
        const json = await response.json();
        if (json.success) {
          notification.success({
            message: "Success",
            description: "Updated Successfully",
            duration: 3,
          });
          setIsDisplay(false);
        } else {
          notification.error({
            message: "Failed",
            description: json?.error,
            duration: 3,
          });
        }
      } else {
        const response = await fetch(`${url}/api/communication/addPEmail`, {
          mode: "cors",
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            email: credentials.email,
            site_id: siteId,
          }),
        });
        setIsLoading(false);
        const json = await response.json();
        if (json.success) {
          notification.success({
            message: "Success",
            description: "Added Successfully",
            duration: 3,
          });
        } else {
          notification.error({
            message: "Failed",
            description: json?.error,
            duration: 3,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const iocnStyle = {
    display: isLoading ? "inline-block" : "none",
  };
  if (!isSuperAdmin) return null;
  return (
    <div className="">
      <div className="row">
        <div className="col-lg-12">
          <div className="mb-3">
            <label className="form-label" htmlFor="pickup-email-site">
              Site
            </label>
            <select
              id="pickup-email-site"
              className="form-control"
              value={siteId}
              onChange={handleSiteChange}
            >
              <option value="">Choose Site</option>
              {sites.map((site) => (
                <option key={site._id} value={site._id}>
                  {site.name}
                </option>
              ))}
            </select>
          </div>
          <div className="">
            <div className="inpt-wrap">
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Pickup Email"
                name="email"
                value={credentials.email}
                onChange={handleInput}
                disabled={!isDisplay}
                required
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12 text-end">
        <div className="">
          <button
            onClick={isDisplay ? handleSubmit : handleChange}
            disabled={isLoading}
            className="btn btn-prim w-auto ms-5"
          >
            <i className="fa fa-spinner fa-spin" style={iocnStyle}></i>{" "}
            {isDisplay ? "Submit" : "Edit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PickupEmail;
